
import {
  defineComponent, ref, Ref, onMounted, computed,
} from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { defineRule, Form } from 'vee-validate';
// eslint-disable-next-line import/no-cycle
import { useMainStore } from '@/store/mainStore';
import AppInput from '@/components/UI/AppInput.vue';
import AppButton from '@/components/UI/AppButton.vue';
import { useRegistrationStore } from '../store/registrationStore';
import ValidationService from '@/services/ValidationService';
// eslint-disable-next-line import/no-cycle
import MonitoringService from '@/services/MonitoringService';
import { HEALTHCARE } from '@/types/enums';

defineRule('onlyNumbers', (value:string) => ValidationService.onlyNumbers(value) || 'Use only numbers');
defineRule('isNPI', (value:string) => ValidationService.isNPI(value) || 'Incorrect NPI number');

export default defineComponent({
  components: {
    Form,
    AppInput,
    AppButton,
  },
  setup() {
    const schema = {
      npi: 'onlyNumbers|isNPI',
    };

    const router = useRouter();
    const route = useRoute();
    const registrationStore = useRegistrationStore();
    const mainStore = useMainStore();

    const npiValue: Ref<string | undefined> = ref(registrationStore.searchUser.npi);
    const errorNPI = computed(() => route.meta.error && npiValue.value === registrationStore.searchUser.npi);
    const skipNpiUrl = computed(() => {
      const { profession } = registrationStore.createUser;
      if (profession === HEALTHCARE.OTHER) {
        return 'step-3a';
      }
      if (profession === HEALTHCARE.NURSING) {
        return 'step-3b';
      }
      if (profession === HEALTHCARE.ALLIED_HEALTH) {
        return 'step-3c';
      }
      if (profession === HEALTHCARE.DENTAL) {
        return 'step-3d';
      }
      if (profession === HEALTHCARE.MEDICAL) {
        return 'step-3e';
      }
      return 'step-7';
    });

    function nextStep() {
      registrationStore.searchUser.npi = npiValue.value;
      router.replace('step-4b');
    }

    onMounted(() => {
      if (!registrationStore.searchUser.lastName) {
        router.push('step-3a');
      }
      MonitoringService.sendPageMountedSpeed();
    });

    return {
      npiValue,
      mainStore,
      schema,
      errorNPI,
      skipNpiUrl,
      nextStep,
    };
  },
});
